// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Mv-z","tooltipWrapper":"Nv-z","icon":"Ov-z","tooltip":"Pv-z","content":"Qv-z"};